/**
 * Program: SDL Common Directive
 * Author: SDL
 * Description: SDL Common Directive List
 */
import custom from './custom';
import clickOutSide from './clickOutside';
import regex from './regex';
import authorization from './authorization';
import validation from './validation';
import columnResize from './columnResize';
import columnFix from './columnFix';

export default {
  install(Vue) {
    Vue.directive('custom', custom);
    Vue.directive('click-outside', clickOutSide);
    Vue.directive('regex', regex);
    Vue.directive('authorization', authorization);
    Vue.directive('validation', validation);
    Vue.directive('columnResize', columnResize);
    Vue.directive('columnFix', columnFix);
  },
};



// WEBPACK FOOTER //
// ./src/directives/index.js